export interface Participant {
  id: string;
  name: string;
  isVideoEnabled: boolean;
  isAudioEnabled: boolean;
  isScreenSharing: boolean;
  isCurrentUser: boolean;
  isHost?: boolean;
  handRaised?: boolean;
  activeEmoji?: string;
  stream?: MediaStream;
}

export interface Device {
  deviceId: string;
  label: string;
}

export interface ChatMessage {
  id: string;
  senderId: string;
  senderName: string;
  text: string;
  timestamp: number;
  scope: 'public' | 'private';
  toSocketId?: string;
}

export interface ParticipantMediaState {
  isAudioEnabled: boolean;
  isVideoEnabled: boolean;
  isScreenSharing?: boolean;
}

export interface ParticipantSignals {
  activeEmoji?: string;
  handRaised?: boolean;
}

export interface FloatingReaction {
  id: string;
  emoji: string;
  leftPercent: number;
}

export interface MeetingTopic {
  id: string;
  title: string;
  /** Dakika */
  duration: number;
  type: string;
  order: number;
}

export type VideoBackgroundEffect = 'none' | 'blur' | 'purple' | 'blue' | 'transparent';

export interface StoredRecording {
  id: string;
  meetingId: string;
  title: string;
  createdAt: number;
  durationSeconds: number;
  sizeBytes: number;
  blob: Blob;
}

export const QUICK_REACTIONS = ['❤️', '👍', '🎉', '👏', '😂', '😮', '😢', '🤔', '👎'] as const;
